import React from 'react';
import type { QuickOption, QuickOptionGroup } from '../types';

interface QuickOptionsProps {
  options: QuickOption[];
  groups: QuickOptionGroup[];
  onSelect: (option: QuickOption) => void;
}

const QuickOptions: React.FC<QuickOptionsProps> = ({ options, groups, onSelect }) => (
  <div className="p-2 max-h-[400px] overflow-y-auto">
    {groups.map((group) => (
      <div key={group.label}>
        <div className="text-xs font-medium text-gray-500 uppercase tracking-wider px-2 py-1">
          {group.label}
        </div>
        {options.slice(group.indices[0], group.indices[1]).map((option) => (
          <button
            key={option.label}
            onClick={() => onSelect(option)}
            className="w-full px-2 py-1.5 text-left text-sm hover:bg-gray-100 rounded flex items-center justify-between group"
          >
            <span>{option.label}</span>
            <span className="text-xs text-gray-500 group-hover:text-gray-700">
              {option.display}
            </span>
          </button>
        ))}
      </div>
    ))}
  </div>
);

export default QuickOptions;
